// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xarBY","tabsBox":"styles_tabsBox__3niDT","createButton":"styles_createButton__1gsTV"};